import { render, staticRenderFns } from "./MarkedLink.vue?vue&type=template&id=44fea1de&"
import script from "./MarkedLink.vue?vue&type=script&lang=ts&"
export * from "./MarkedLink.vue?vue&type=script&lang=ts&"
import style0 from "./MarkedLink.vue?vue&type=style&index=0&id=44fea1de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports